export const isProd = process.env.NODE_ENV === 'production'

export const isDev = process.env.NODE_ENV === 'development'

export const isBrowser = typeof window !== 'undefined'

export const siteURL = process.env.NEXT_PUBLIC_SITE_URL || ''

export const apiURL = process.env.NEXT_PUBLIC_API || ''
